let bodyUnfixPosition = () => {
    if (document.body.hasAttribute("data-body-scroll-fix")) {
        let scrollPosition = document.body.getAttribute(
            "data-body-scroll-fix"
        ); // Получаем позицию прокрутки из атрибута
        document.body.removeAttribute("data-body-scroll-fix"); // Удаляем атрибут
        document.body.removeAttribute("style");
        window.scroll(0, scrollPosition); // Прокручиваем на полученное из атрибута значение
    }
    let form_clear = document.querySelectorAll("form");
    if (form_clear) {
        [].forEach.call(form_clear, function (item) {
            let data = item.querySelector(".form-data__input");
            let result = item.querySelector(".form-data__result");
            let message = item.querySelector(".message");
            if (data) data.classList.remove("hide");
            if (result) result.classList.add("hide");
            if (message) {
                item.querySelector(".message").innerHTML = "";
            }
        });
    }
};

export default bodyUnfixPosition;
